import { createContext } from 'react'

import { type SupportLine } from '@onr/schema'
import { type User } from 'firebase/auth'

export interface FirebaseUserContextValue {
  readonly firebaseUser: User
  readonly permissions: string[]
  readonly sys_admin: boolean
  readonly super_admin: boolean
  readonly judicial_admin: boolean
  readonly canToggleWaitTime: boolean
  readonly canToggleMobileApp: boolean
  readonly regionId: string | null
  readonly piloteUserId: number | null
  readonly firstName: string | null
  readonly lastName: string | null
  readonly supportRole: SupportLine | null
  readonly supportRequester: boolean
  readonly supportOnly: boolean
  signOut(): Promise<void>
}

export const FirebaseUserContext = createContext<FirebaseUserContextValue | null>(null)
